import {
    LOGIN_REQUEST,
    RESET_PASS_REQUEST,
    RESET_PASS_EMAIL_REQUEST,
} from './login.actions';
import {services} from './login.services';
import actions from '../redux/actions';
import {_saveToken} from '../utils/httpUtils';
import {toast} from 'react-toastify';

const loginMiddleware = ({dispatch, getState}) => (next) => (action) => {
    next(action);
    switch (action.type) {
        case LOGIN_REQUEST:
            toast.info('Iniciando Sesión');
            services
                .login({
                    email: action.body.email,
                    password: action.body.password,
                    captchaResponse: action.body.captchaResponse,
                })
                .then((res) => {
                    _saveToken(res.response.jwt);
                    const salesforceBranchName = res.response.provider?.salesforceProvider?.branch?.fullName ||
                        res.response.provider?.salesforceProvider?.branch?.address;
                    switch (res.response.user.role.name) {
                        case 'ADMIN':
                            localStorage['name'] = res.response.user.firstName ?
                                res.response.user.firstName + ' ' + res.response.user.lastName:
                                res.response.user.email;
                            break;
                        case 'PROVIDER_ADMIN':
                            localStorage['name'] = 'Administrador - ' + res.response.provider.salesforceProvider.provider.fullName;
                            break;
                        case 'PROVIDER_USER':
                            localStorage['name'] = res.response.provider.salesforceProvider.provider.fullName + ' - ' +
                                salesforceBranchName;
                            break;
                        case 'PROVIDER_USER_QUOTER':
                        case 'PROVIDER_USER_VIEWER':
                            localStorage['name'] = res.response.provider.salesforceProvider.provider.fullName + ' - ' +
                                salesforceBranchName;
                            break;
                        case 'DEVELOPER':
                            localStorage['name'] = 'Desarrollador - ' + res.response.provider.salesforceProvider.provider.fullName;
                            break;
                        default:
                            localStorage['name'] = res.response.provider.name;
                            break;
                    }
                    localStorage['sessionTime'] = Date.now();
                    dispatch(actions.login.loginResponse(res));
                })
                .catch((error) => {
                    console.error(error);
                    dispatch(actions.login.loginResponseError(error));
                    toast.dismiss();
                    toast.error('Ha ocurrido un error');
                });
            break;

        case RESET_PASS_REQUEST:
            services
            .resetPass(action.body)
            .then((res) => {
                    toast.success('Contrasena cambiada');
                    dispatch(actions.login.resetPassResponse(res));
                })
                .catch((error) => {
                    dispatch(actions.login.resetPassResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        case RESET_PASS_EMAIL_REQUEST:
            toast.info('Enviando email');
            services
                .resetPassEmail(action.body)
                .then((res) => {
                    toast.success('Email de cambio de contrasena enviado');
                    dispatch(actions.login.resetPassEmailResponse(res));
                })
                .catch((error) => {
                    dispatch(actions.login.resetPassEmailResponseError(error));
                    toast.error('Ha ocurrido un error');
                });
            break;
        default: break;
    }
};

export default loginMiddleware;
